import {NumericFieldWidget} from "./NumericFieldWidget";
import {getFieldDisplayMask} from "../login/ClientCache";

export class IntegerFieldWidget extends NumericFieldWidget {
    afterAttach() {
        super.afterAttach();
        let that = this;
        that.numericField = that.findElement().kendoNumericTextBox({
            format: getFieldDisplayMask(that.owner.entityType, that.id) || "n0",
            decimals: 0,
            spinners: !that.insideGrid
        }).data("kendoNumericTextBox");
    }
}